/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import { getPropStylesFactory } from '@/utils/getPropStylesFactory';
import { getComponentStylesFactory } from '@/utils/getComponentStylesFactory';
import { getComponentThemeFactory } from '@/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "arrow_colors_default": "",
  "arrow_size_default": "pr-6",
  "arrow_variant_default": "cursor-pointer hidden md:flex absolute data-[direction=next]:rotate-180 top-1/2 -translate-y-1/2 data-[direction=next]:right-0 data-[direction=prev]:left-0",
  "content_colors_default": "",
  "content_size_default": "md:px-12",
  "content_variant_default": "flex flex-col w-full",
  "group_colors_default": "",
  "group_size_default": "w-full",
  "group_variant_default": "flex flex-nowrap relative",
  "navigation_item_colors_default": "bg-gray-100 data-[active=true]:bg-cherry-blossom-500",
  "navigation_item_size_default": "w-2 h-2",
  "navigation_item_variant_default": "rounded-full",
  "navigation_colors_default": "",
  "navigation_size_default": "gap-x-3 mt-6",
  "navigation_variant_default": "flex justify-center md:hidden",
  "title_colors_default": "text-black",
  "title_size_default": "text-headline-xs font-bold pb-3 md:pb-6",
  "title_variant_default": "text-center",
  "colors_default": "",
  "size_default": "w-full",
  "variant_default": ""
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "SliderSwiper");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;